import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { GridColumnsConfiguration } from 'src/app/components/shared/grid/grid.component';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';

@Component({
  selector: 'neoris-sanity-plant',
  templateUrl: './sanity-plant.component.html',
  styleUrl: './sanity-plant.component.css'
})
export class SanityPlantComponent implements OnInit {

  public sanityIcons: { icon: string, status: boolean, subTitle: string, toolTip: string }[] = [
    {
      icon: "../assets/images/controlTowers/camera-ico.svg",
      status: true,
      subTitle: "",
      toolTip: "Camera Status"
    },
    {
      icon: "../assets/images/controlTowers/computer-ico.svg",
      status: true,
      subTitle: "",
      toolTip: "Computer Status"
    },
    {
      icon: "../assets/images/controlTowers/image-sync-ico.svg",
      status: true,
      subTitle: "",
      toolTip: "Image Sync Status"
    }
  ]


  public gridTitle: string = "Cameras"
  public columnsConfiguration: GridColumnsConfiguration = {
    ShowAddButton: false,
    IconValue: undefined,
    IconColumnName: undefined,
    hiddenColumnNames: [
      "ROW_ID"
    ],
    dateColumns: [],
    cardColum: "DockerName",
    cardValues: [
      { place: 0, nombre: 'DockerName', isMainColumn: false }
    ],
    listColumns: [
    ],
    MultiIconColumns: [
      {
        columnName: "c01",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c02",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c03",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c04",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c05",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c06",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c07",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c08",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c09",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c10",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c11",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c12",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c13",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c14",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c15",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c16",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      },
      {
        columnName: "c17",
        propertyName: "value",
        icons: [
          {
            value: "true",
            iconUrl: "../assets/images/controlTowers/pointer-status-true.png"
          },
          {
            value: "false",
            iconUrl: "../assets/images/controlTowers/pointer-status-false.png"
          }
        ]
      }
    ],
    ActionColumn: {
      ColumnName: undefined,
      Actions: []
    }
  }

  public gridData: {
    ROW_ID: number,
    DockerName: string,
    LastEvent: string,
    c01: { value: string }[],
    c02: { value: string }[],
    c03: { value: string }[],
    c04: { value: string }[],
    c05: { value: string }[],
    c06: { value: string }[],
    c07: { value: string }[],
    c08: { value: string }[],
    c09: { value: string }[],
    c10: { value: string }[],
    c11: { value: string }[],
    c12: { value: string }[],
    c13: { value: string }[],
    c14: { value: string }[],
    c15: { value: string }[],
    c16: { value: string }[],
    c17: { value: string }[]
  }[] = [
      {
        ROW_ID: 0,
        DockerName: "Docker01",
        LastEvent: "2025-01-01 00:00:00",
        c01: [{ value: "true" }],
        c02: [{ value: "true" }],
        c03: [{ value: "true" }],
        c04: [{ value: "true" }],
        c05: [{ value: "true" }],
        c06: [{ value: "true" }],
        c07: [{ value: "true" }],
        c08: [{ value: "true" }],
        c09: [{ value: "true" }],
        c10: [{ value: "true" }],
        c11: [{ value: "true" }],
        c12: [{ value: "true" }],
        c13: [{ value: "true" }],
        c14: [{ value: "true" }],
        c15: [{ value: "true" }],
        c16: [{ value: "true" }],
        c17: [{ value: "false" }]
      }, {

        ROW_ID: 1,
        DockerName: "Docker01",
        LastEvent: "2025-01-01 00:00:00",
        c01: [{ value: "true" }],
        c02: [{ value: "true" }],
        c03: [{ value: "true" }],
        c04: [{ value: "true" }],
        c05: [{ value: "true" }],
        c06: [{ value: "true" }],
        c07: [{ value: "true" }],
        c08: [{ value: "true" }],
        c09: [{ value: "true" }],
        c10: [{ value: "true" }],
        c11: [{ value: "true" }],
        c12: [{ value: "true" }],
        c13: [{ value: "true" }],
        c14: [{ value: "true" }],
        c15: [{ value: "true" }],
        c16: [{ value: "true" }],
        c17: [{ value: "true" }]
      }, {

        ROW_ID: 2,
        DockerName: "Docker02",
        LastEvent: "2025-01-01 00:00:00",
        c01: [{ value: "false" }],
        c02: [{ value: "false" }],
        c03: [{ value: "false" }],
        c04: [{ value: "false" }],
        c05: [{ value: "false" }],
        c06: [{ value: "false" }],
        c07: [{ value: "false" }],
        c08: [{ value: "false" }],
        c09: [{ value: "false" }],
        c10: [{ value: "false" }],
        c11: [{ value: "false" }],
        c12: [{ value: "false" }],
        c13: [{ value: "false" }],
        c14: [{ value: "false" }],
        c15: [{ value: "false" }],
        c16: [{ value: "false" }],
        c17: [{ value: "false" }]
      }
      , {
        ROW_ID: 3,
        DockerName: "Docker03",
        LastEvent: "2025-01-01 00:00:00",
        c01: [{ value: "true" }],
        c02: [{ value: "true" }],
        c03: [{ value: "true" }],
        c04: [{ value: "true" }],
        c05: [{ value: "true" }],
        c06: [{ value: "true" }],
        c07: [{ value: "true" }],
        c08: [{ value: "true" }],
        c09: [{ value: "true" }],
        c10: [{ value: "true" }],
        c11: [{ value: "true" }],
        c12: [{ value: "true" }],
        c13: [{ value: "true" }],
        c14: [{ value: "true" }],
        c15: [{ value: "true" }],
        c16: [{ value: "true" }],
        c17: [{ value: "true" }]
      }
    ]

  constructor(private controltowerservice: ControltowerService) {
  }

  ngOnInit(): void {

  }

  public sanityData: any = []


  private async GetSanityCheck(): Promise<boolean> {
    let sitesId: string = localStorage.getItem('site');
    let localeCode: string = "en"

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetSanityCheck(sitesId, localeCode).subscribe(
        {
          next: (result: any = {}) => {


            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

}
